module.exports = __webpack_public_path__ + "static/metaphor-ccabfd0b00766ddd60ba2bec9be5f2ae.jpg";